module.exports = __webpack_public_path__ + "img/medico_solicitante.25bbe6e8.gif";